import { SB } from '@play-co/replicant';

export const settings = SB.object({
  locale: SB.string(),
  receiveMessages: SB.tuple(['on', 'less', 'off']).default('on'),
  music: SB.boolean().default(true),
  sound: SB.boolean().default(true),
  // Only some users can edit this
  decorationEditor: SB.boolean().default(false),

  // undefined until user has seen the push notification permission popup
  pushNotifications: SB.boolean().optional(),
});
